import initI18n from './init-i18n';
import { useCommonTranslation as useTranslation } from './utils';

/** Always export the instance returned by init so bundlers cannot tree-shake init away. */
const i18n = initI18n();

export { i18n, initI18n, useTranslation };
export type { Namespace } from './resources';
export { I18nextProvider } from 'react-i18next';
export { createUseAppTranslation } from './utils';
export type {
  NamespaceKeys,
  AppTranslationFunctionType,
  AppTranslationArrayFunctionType,
} from './utils';

export * from './components';

export * from './hooks';
